<template>
	<div>
		<hero :content="heroContent" @hamburger="hamburgerClicked"></hero>
		<div class="clearfix">
			<voters class="voters col-xs-12"></voters>
		</div>
		<div class="clearfix topper">
			<critic-quote :criticSliderContent="criticSlider1" class="col-xs-12 no-pad"></critic-quote>
			<div class="col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme">
					<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p-01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p_1.webm" type='video/webm' />
				</video>
			</div>
		</div>
		<div class="clearfix topper">
			<production-quote id="bestPictureProdQuote1" class="col-xs-12 no-pad" :prodQuote="productionQuote1"></production-quote>
		</div>
		<div class="clearfix grid topper">
			<production-quote id="bestPictureProdQuote2" class="col-xs-12 col-md-6 col-md-push-6 no-pad" :prodQuote="productionQuote2"></production-quote>
			<div class="col-xs-12 col-md-6 col-md-pull-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_actress_block_1.jpg" alt="Three Billboards"></div>
			<production-quote id="bestPictureProdQuote3" class="col-xs-12 col-md-6 no-pad" :prodQuote="productionQuote3"></production-quote>
			<div class="col-xs-12 col-md-6 image hideme"><img src="https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_picture_block_2.jpg" alt="Three Billboards"></div>
		</div>
		<div class="clearfix">
			<div class="col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme">
				<video class="video-js vjs-default-skin" controls preload="none" data-setup='{"fluid": true}' poster="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p-01.jpg">
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p.mp4" type='video/mp4' />
					<source src="https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/TBOEM_OnlineTrailer_PointyRev_Prores_1080p_1.webm" type='video/webm' />
				</video>
			</div>
		</div>
		<click-thru :clickThru="clickThru" @clickThru="nextCategory"></click-thru>
		<social></social>
		<legal></legal>
	</div>
</template>
<script>
import Hero from '../../components/Hero';
import Voters from '../../components/Voters';
import CriticQuote from '../../components/CriticQuote';
import ProductionQuote from '../../components/ProductionQuote';
import ClickThru from '../../components/ClickThru';
import Social from '../../components/Social';
import Legal from '../../components/Legal';

export default {
	name: 'best-actress',
	data: function() {
		return {
			heroContent: {
				"image": "best-actress-3b-lg",
				"mobileImage": "best-actress-3b-mob",
				"superHeader": "For Your Consideration",
				"header": "Best Actress",
				"subHeader": ['FRANCES McDORMAND'],
				"isSubPage": true
			},
			clickThru: {
				superHeader: 'Next Category',
				mainText: 'Best Supporting Actor',
				clickThruPath: ''
			},
			criticSlider1: [
				{
					text: "McDormand gives a revelatory performance — her best since her Oscar-winning turn in ‘Fargo’.",
					author: '- ASSOCIATED PRESS'
				},
				{
					text: "Frances McDormand is an absolute force of nature.",
					author: '- INDIEWIRE'
				},
				{
					text: "&#9733; &#9733; &#9733; &#9733;<br />A livewire Frances McDormand will blow you away as Mildred Hayes. She is phenomenal, a combustible force of nature.",
					author: '- ROLLING STONE'
				},
			],
			productionQuote1: {
				text: "I wrote Mildred for Frances. There wasn’t any other actress I thought had all the elements that Mildred needed. She had to be very in touch with a kind of working class sensibility as well as a rural sensibility. She also had to be someone who wouldn’t sentimentalize the character. All of Frances’s work is fundamentally truthful. I knew she could play the darkness of Mildred yet also have dexterity with the humor, while staying true to who Mildred is throughout.",
				author: "- Martin McDonagh"
			},
			productionQuote2: {
				text: "Frances is such a fierce actor and her particular mix of tenacity and compassion matches Mildred. She brings that fight-or-die quality.",
				author: "- Sam Rockwell"
			},
			productionQuote3: {
				text: "I could see it in her walk and her attitude. I think John Wayne did become a touchstone to a degree for Frances. But I also see Brando and Montgomery Clift in there, too.",
				author: "- Martin McDonagh"
			},
		}
	},
	components: {
		Hero,
		Voters,
		CriticQuote,
		ProductionQuote,
		ClickThru,
		Social,
		Legal
	},
	methods: {
		hamburgerClicked: function() {
			console.log('hamburger passing through BestProduction');
			this.$emit('hamburger');
		},
		nextCategory: function() {
			console.log('nextCategory at categorypage');
			this.$emit('clickThru')
		}
	}
}
</script>


// WEBPACK FOOTER //
// BestActress.vue?30d50860